import React, { useState, useEffect } from 'react';
import { subscribeToSiteSettingsFromFirestore, getLocalSiteSettings, SiteSettings } from '../lib/siteSettingsService';

interface RhLogoProps {
  className?: string;
  size?: number;
  variant?: 'header' | 'auth' | 'footer' | 'email';
  customUrl?: string;
}

export const RhLogo: React.FC<RhLogoProps> = ({
  className = 'w-10 h-10',
  size,
  variant = 'header',
  customUrl
}) => {
  const [settings, setSettings] = useState<SiteSettings>(getLocalSiteSettings());

  const logoImgUrl = customUrl || (
    variant === 'auth' ? (settings.siteLogoAuthUrl || settings.siteLogoHeaderUrl) :
    variant === 'footer' ? (settings.siteLogoFooterUrl || settings.siteLogoHeaderUrl) :
    variant === 'email' ? (settings.siteLogoEmailUrl || settings.siteLogoHeaderUrl) :
    settings.siteLogoHeaderUrl
  ) || "/assets/logo.svg";

  useEffect(() => {
    const unsub = subscribeToSiteSettingsFromFirestore((newSettings) => {
      setSettings(newSettings);
    });
    return () => unsub();
  }, []);

  return (
    <div
      className={`relative aspect-square inline-flex items-center justify-center flex-shrink-0 select-none overflow-hidden ${className}`}
      style={size ? { width: size, height: size } : undefined}
    >
      <img
        src={logoImgUrl}
        alt="RH Editography Logo"
        referrerPolicy="no-referrer"
        className="w-full h-full object-contain filter drop-shadow-[0_4px_12px_rgba(168,85,247,0.35)] transition-transform duration-300 group-hover:scale-105 rounded-md"
      />
    </div>
  );
};
